const Set_Quote_Summaries = (state, quoteSummaries) => {
  state.quoteSummaries = quoteSummaries;
};

const Set_Quotes = (state, quotes) => {
  state.quotes = quotes;
};

const Set_Quote = (state, quote) => {
  state.quote = quote;
};

export default {
  Set_Quotes,
  Set_Quote_Summaries,
  Set_Quote
};
